// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2CIIu","colMaxWidth":"Table_colMaxWidth__ACa9m"};